<template>
  <div class="auth-form__form-wrapper">
    <form class="auth-form__form" @submit.prevent="validateFields">
      <Title
        header="Sign in to your INE account"
        :tagline="`Sign in to join ${invitationCompany}'s account.`"
        class="auth-form__business-title"
      />
      <p
        class="auth-form__with-email"
        v-if="invitationEmail && loginWithPersonal"
      >
        Enter your password for {{ invitationEmail }}
      </p>
      <div class="auth-form__form-group" v-if="loginWithPersonal">
        <div
          v-for="(field, key) in fields"
          v-show="field.type"
          :key="`field-${key}`"
          class="auth-form__input-wrapper"
        >
          <input
            v-if="field.type && !field.hidden"
            :type="field.type"
            :class="[
              'ine-input auth-form__form-control',
              errors.fields.includes(key) && 'ine-input--error',
            ]"
            @focus="clearErrors"
            :placeholder="field.placeholder"
            :autocomplete="field.autocomplete"
            v-model="field.value"
          />
          <Errors v-if="errors.fields.includes(key)" :errors="errors[key]" />
        </div>
      </div>
      <div class="auth-form__form-group" v-else>
        <input
          type="text"
          class="auth-form__form-control ine-input"
          @focus="clearErrors"
          placeholder="Company Name"
          v-model="companyName"
        />
      </div>
      <div class="auth-form__actions">
        <div class="auth-form__actions-group">
          <SubmitBtn
            class="auth-form__actions-submit-wrapper"
            extraButtonClasses="auth-form__actions__submit"
            title="Sign In"
            :isLoading="isLoading"
          />
          <router-link
            v-if="loginWithPersonal"
            :to="{ name: 'forgot-password' }"
          >
            <button class="btn btn--tertiary">Forgot your password?</button>
          </router-link>
        </div>
        <div class="auth-form__oauth">
          <span
            class="auth-form__oauth-separator auth-form__oauth-separator--business"
            >OR</span
          >
        </div>
        <div class="auth-form__providers-wrapper">
          <button
            v-for="provider in authProviders"
            :key="`provider-${provider.id}`"
            class="btn btn--secondary btn--default-icon-color"
            @click.prevent="$emit('login-through-provider', provider)"
            :disabled="isLoading"
          >
            <GoogleIcon class="auth-form__oauth__icon" /> Log In with
            {{ provider.name }}
          </button>
          <button
            :key="'provider-company'"
            class="btn btn--secondary auth-form__sso-button"
            @click.prevent="togglePersonal"
            :disabled="isLoading"
          >
            Sign in with your {{ account }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import GoogleIcon from '@/assets/icons/fill/google.svg'

export default {
  name: 'LoginForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    GoogleIcon,
  },
  data() {
    return {
      errors: clearFormErrors(),
      fields: {
        email: {
          type: 'email',
          placeholder: 'Email',
          rules: [],
          value: '',
          autocomplete: 'email',
          hidden: false,
        },
        password: {
          type: 'password',
          placeholder: 'Password',
          rules: ['presence'],
          value: '',
          autocomplete: 'current-password',
          hidden: false,
        },
      },
      loginWithPersonal: true,
      companyName: null,
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    authProviders: {
      type: Array,
      required: true,
    },
    invitation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    account() {
      return this.loginWithPersonal ? 'company' : 'personal account'
    },
    invitationFrom() {
      return this.invitation?.invited_by?.first_name || ''
    },
    invitationCompany() {
      return this.invitation.account.name
    },
    invitationEmail() {
      return this.invitation.user_invite?.email
    },
  },
  methods: {
    async validateFields() {
      const { fields } = this
      if (!this.loginWithPersonal) {
        this.$emit('submit-company', this.companyName)
        return
      }
      const { isValid, errors } = validateForm(fields)
      this.errors = errors
      if (isValid) {
        const payload = {
          email: fields.email.value || this.invitationEmail,
          password: fields.password.value,
        }
        this.$emit('submit-form', payload)
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
    togglePersonal() {
      this.loginWithPersonal = !this.loginWithPersonal
    },
  },
  mounted() {
    if (this.invitationEmail) {
      this.fields.email.hidden = true
    } else {
      this.fields.email.rules = ['presence', 'email']
    }
  },
}
</script>
